export enum CmLicensePermissions {
    Console = 'Console',
    WorkbenchCommandEditor = 'Workbench: Command Editor',
    WorkbenchCommandDesigner = 'Workbench: Command Designer',
    DeviceConnections = 'Device Connections',
    CommandAdmin = 'Command Administration',
    CustomerAdmin = 'Customer Administration',
}
